/**
 * Pastille de statut juridique d'un texte réglementaire, projetée depuis le champ
 * select « statut » d'une fiche (C.68) : « Texte historique » sur les versions
 * remplacées, « En vigueur » sur la version courante des chaînes qualifiées par la
 * DSIF. Le ton choisit la couleur : ambre discret pour l'historique, le chip bleu
 * de la palette pour le reste. Composant purement présentationnel, rendu côté
 * serveur (fiche) comme côté client (cartes de liste).
 */
export function StatusBadge({ badge }: { badge?: { label?: string; tone?: string } | null }) {
  const label = (badge?.label ?? "").toString().trim();
  if (!label) return null;
  const tone = (badge?.tone ?? "").toString().trim();
  const toneClasses =
    tone === "historique"
      ? "border-[#FFA401]/40 bg-[#FFF7E6] text-[#8A6210]"
      : "border-[#005CA9]/20 bg-[#EAF6FF] text-[#005CA9]";
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] xl:text-[12px] font-semibold ${toneClasses}`}
    >
      {label}
    </span>
  );
}
